import { render, staticRenderFns } from "./DataObjectGraph.vue?vue&type=template&id=2c076626&scoped=true&"
import script from "./DataObjectGraph.vue?vue&type=script&lang=js&"
export * from "./DataObjectGraph.vue?vue&type=script&lang=js&"
import style0 from "./DataObjectGraph.vue?vue&type=style&index=0&id=2c076626&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c076626",
  null
  
)

export default component.exports